import React from "react";
import "../style/input-mail.css"; // Import the CSS file

const ContactForm = () => {
  return (
    <form
      id="contact-form"
      action="https://formspree.io/f/xwpogrro"
      method="POST"
    >
      <div className="form-container">
        {" "}
        {/* Renamed from in-put-all-in for clarity */}
        <h3 className="form-description">
          {" "}
          {/* Renamed from desc-text */}
          Need construction-related information? I’m here to help — feel free to
          ask!
        </h3>
        <div className="input-group-main">
          {" "}
          {/* Renamed from in-put-all */}
          <div className="input-group-three-col">
            {" "}
            {/* Renamed from in-put-3 */}
            <input type="text" name="name" placeholder="Your Name" required />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              required
            />
          </div>
          <textarea
            name="message"
            placeholder="Description"
            rows="6"
            required
          ></textarea>{" "}
          {/* Added rows for better initial height */}
          <button type="submit" className="submit-button">
            Send
          </button>{" "}
          {/* Added class for styling */}
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
